export default {
  timeslots: [],
  employees: [],
};
